export default __webpack_public_path__ + "static/shape_diamond_male-aae11e929c72a3745b2041537dc25e61.png";